<template>
  <div
    v-if="badgesFilteredBcom.length"
    class="badges-simplification"
  >
    <div
      v-if="isBcomFinalOffer"
      class="final-price eyebrow"
    >
      THE FINAL OFFER
    </div>
    <div
      v-for="badgeToShow of badgesToShowList"
      :key="badgeToShow"
      class="badge-wrapper small"
    >
      <div class="badge-container">
        <LoyaltyStarIcon
          :loyalty-badge="loyaltyBadge"
          :badge="badgeToShow"
        />
        <span
          :class="[{'badge-free-gwp' : isFreeGwp(badgeToShow)}, {'eyebrow flexText' : isBcom && !overridePriceSimplification}]"
        > {{ displayHeader(badgeToShow,overridePriceSimplification) }}
          <button
            v-if="badgeToShow?.description && !suppressToolTip && !overridePriceSimplification
              && !isRemoveTooltipOnFgwpBadgeEnabled(badgeToShow, removeTooltipOnFgwpBadgeEnabled) && !isBcom"
            v-tooltip.bottom="{
              value: getTooltipContent(badgeToShow),
              escape: true
            }"
            class="tooltip-small"
            @click.once="plpToolTipClick()"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* istanbul ignore file */
import Tooltip from '@atomic-ui/tooltip';
import isBcom from '../../../utils/isBcom';
import {
  isFreeGwp,
  displayHeader,
  getTooltipContent,
  plpToolTipClick,
  isRemoveTooltipOnFgwpBadgeEnabled,
} from '../../../utils/pricingBlockUtil';
import LoyaltyStarIcon from './LoyaltyStarIcon';

export default {
  name: 'BadgesSimplification',
  directives: {
    tooltip: Tooltip,
  },
  components: { LoyaltyStarIcon },
  props: {
    badgesData: {
      type: Array,
      default: () => [],
    },
    loyaltyBadge: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    suppressToolTip: {
      type: Boolean,
      default: false,
    },
    overridePriceSimplification: {
      type: Boolean,
      default: false,
    },
    removeTooltipOnFgwpBadgeEnabled: {
      type: Boolean,
      default: false,
    },
    hasBadgePriceData: {
      type: Boolean,
      default: false,
    },
    isBcomFinalOffer: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isBcom,
      isFreeGwp,
      displayHeader,
      getTooltipContent,
      plpToolTipClick,
      isRemoveTooltipOnFgwpBadgeEnabled,
    };
  },
  computed: {
    badgesToShowList() {
      const badges = [];

      // Early return if no badges data
      if (!this.badgesData || !this.badgesData.length) {
        return badges;
      }

      // Bcom shows all badges available - remove promo and final price as they are not badges
      if (isBcom) {
        return this.badgesFilteredBcom;
      }

      // For Mcom - finds freeGWP badge if found,
      // then shows first other available badge

      // Single pass through the badges data
      let foundFreeGWP = false;
      let foundSecondBadge = false;

      for (let i = 0; i < this.badgesData.length; i++) {
        const currentBadge = this.badgesData[i];

        // Check for freeGWP badge
        if (!foundFreeGWP && isFreeGwp(currentBadge)) {
          badges.push(currentBadge);
          foundFreeGWP = true;

          // If we've found both types of badges, we can stop
          if (foundSecondBadge) break;
          continue; // eslint-disable-line no-continue
        }

        // Check for secondary badge with header
        if (!foundSecondBadge && currentBadge.header && !isFreeGwp(currentBadge)) {
          // Skip zero idx badge if hasBadgePriceData to avoid duplication of With Offer products
          if (i === 0 && this.hasBadgePriceData) continue; // eslint-disable-line no-continue

          badges.push(currentBadge);
          foundSecondBadge = true;

          // If we've found both types of badges, we can stop
          if (foundFreeGWP) break;
        }
      }

      return badges;
    },
    badgesFilteredBcom() {
      return this.badgesData.filter((badge) => !(badge.promoCode || badge.secondBadgeWithFinalPrice));
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@core/csg/src/scss/encodedIcons/mcom/_tooltip-small.scss';

.pricing {
  .badge-free-gwp {
    background-color: #FCE8EA;
    padding: 0px 8px;
    display: inline-block;
    &::first-letter {
      text-transform: uppercase;
    }
  }
  .badge-wrapper {
    margin-top: rem-calc(8);
    + .badge-wrapper {
      margin-top: rem-calc(4);
    }
    .tooltip-small {
      vertical-align: bottom;
      background-size: 18px 18px;
      margin-left: 2px;
      height: 18px;
      width: 18px;
    }
  }
}
</style>

<style lang="scss" brand="mcom">
  .p-tooltip.p-component .p-tooltip-text {
    white-space: normal;
    .tooltip-content {
    display: flex;
    flex-direction: column;

    &__header {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
    }
  }
}

.badge-container{
  display: flex;
  span{
    align-self: center;
  }
}
</style>

<style lang="scss" brand="bcom" scoped>
.badge-wrapper {
  .flexText, .newMarkdown {
    color: $gray-1-color;
  }
  .loyaltyBadge {
    color: $loyalty-1-color;
  }
}
.final-price {
  margin-top: rem-calc(8);
  + .badge-wrapper {
    margin-top: rem-calc(4);
  }
  color: $gray-1-color;
}
</style>
